var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-item"},[(!_vm.isOpen)?_c('div',{staticClass:"news-wrapper",class:{loading: _vm.loading}},[(!_vm.loading)?_c('v-lazy-image',{attrs:{"src":_vm.item.photoUrl,"alt":_vm.item.name[_vm.locale]}}):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }